import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import classNames from 'classnames';
import moment from 'moment';
import _ from 'lodash';
import Translate from 'translate';

import ChannelCaseService from 'services/ChannelCaseService'
import { toggleLoading } from 'stores/actions/';

class LogDetail extends React.Component {

  render() {
    const { data, onClose, open } = this.props;

    return (
      <Modal closeOnEsc={false}
             little
             modalClassName="col-md-6"
             open={open}
             onClose={onClose}>
        <h5 className="mt-0"><Translate id="logDetail"/></h5>

        {!!data &&
        <div>
          <div className="row">
            <div className="col-md-6">
              <p><strong><Translate id="origin"/>:</strong> {data.origin || '---'}</p>
            </div>
            <div className="col-md-6">
              <p><strong><Translate id="action"/>:</strong> {data.action || '---'}</p>
            </div>
            <div className="col-md-6">
              <p><strong><Translate
                id="createdAt"/>:</strong> {moment( data.createdAt ).format( 'DD/MM/YYYY h:mm A' )}
              </p>
            </div>
            <div className="col-md-6">
              <p><strong><Translate id="statusResponse"/>:</strong> {data.statusResponse || '---'}</p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <p><strong><Translate id="url"/>:</strong> {data.url || '---'}</p>
            </div>
          </div>
          <div className="row" style={{maxHeight: '200px', overflowY: 'auto', wordBreak: 'break-all'}}>
            <div className="col-md-12">
              <p><strong><Translate id="body"/>:</strong> {data.body || '---'}</p>
            </div>
          </div>
          <div className="row" style={{maxHeight: '200px', overflowY: 'auto', wordBreak: 'break-all'}}>
            <div className="col-md-12">
              <p><strong><Translate id="response"/>:</strong> {data.response || '---'}</p>
            </div>
          </div>
        </div>
        }
      </Modal>
    )
  }
}

module.exports = LogDetail;




// WEBPACK FOOTER //
// ./routes/app/components/Management/LogDetail/index.js